import FingerprintJS, {
  defaultEndpoint,
  defaultScriptUrlPattern,
} from "@fingerprintjs/fingerprintjs-pro";
import { FpModel } from "../model/fp";
import { environment } from "environments/environment";
import {
  ALLOW_BROWSERS_ANDROID,
  ALLOW_BROWSERS_IOS,
  AppConsts,
} from "app/shared/consts/app-consts";
import { ugiftPath } from "app/config/config";
import { AppComponent } from "app/app.component";
import { Router } from "@angular/router";

export class CommonUtil {
  private static anccents =
    "ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚÝàáâãèéêìíòóôõùúýĂăĐđĨĩŨũƠơƯưẠạẢảẤấẦầẨẩẪẫẬậẮắẰằẲẳẴẵẶặẸẹẺẻẼẽẾếỀềỂểỄễỆệỈỉỊịỌọỎỏỐốỒồỔổỖỗỘộỚớỜờỞởỠỡỢợỤụỦủỨứỪừỬửỮữỰựỲỳỴỵỶỷỸỹ";
  private static replacement =
    "AAAAEEEIIOOOOUUYaaaaeeeiioooouuyAaDdIiUuOoUuAaAaAaAaAaAaAaAaAaAaAaAaEeEeEeEeEeEeEeEeIiIiOoOoOoOoOoOoOoOoOoOoOoOoUuUuUuUuUuUuUuYyYyYyYy";
  static GetBrowerName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf("edge") > -1:
        return Browser.EDGE;
      case agent.indexOf("opr") > -1 && !!(<any>window).opr:
        return Browser.OPERA;
      case agent.indexOf("chrome") > -1 && !!(<any>window).chrome:
        return Browser.CHROME;
      case agent.indexOf("trident") > -1:
        return Browser.IE;
      case agent.indexOf("firefox") > -1:
        return Browser.FIREFOX;
      case agent.indexOf("safari") > -1:
        return Browser.SAFARI;
      default:
        return Browser.OTHER;
    }
  }

  public static removeVietnameseAnccent(src: string): string {
    if (!src) {
      return "";
    }
    for (var i = 0, l = this.anccents.length; i < l; i++) {
      src = src.replace(RegExp(this.anccents[i], "gi"), this.replacement[i]);
    }
    return src;
  }
}

export function getOS() {
  const userAgent = window.navigator.userAgent,
    platform =
      (window.navigator as any)?.userAgentData?.platform ||
      window.navigator.platform,
    macosPlatforms = ["macOS", "Macintosh", "MacIntel", "MacPPC", "Mac68K"],
    windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
    iosPlatforms = ["iPhone", "iPad", "iPod"];
  let os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "Mac OS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (/Linux/.test(platform)) {
    os = "Linux";
  }

  return os;
}

export function getBrowserName() {
  var sBrowser,
    sUsrAg = navigator.userAgent;
  // The order matters here, and this may report false positives for unlisted browsers.
  if (sUsrAg.toLowerCase().indexOf("zalo") > -1) {
    sBrowser = "Zalo webview";
  } else if (sUsrAg.indexOf("Firefox") > -1) {
    sBrowser = "Mozilla Firefox";
    // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
  } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
    sBrowser = "brave";
    // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
  } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
    sBrowser = "Opera";
    // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
  } else if (sUsrAg.indexOf("Trident") > -1) {
    sBrowser = "Microsoft Internet Explorer";
    // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
  } else if (sUsrAg.indexOf("Edge") > -1) {
    sBrowser = "Microsoft Edge (Legacy)";
    // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
  } else if (sUsrAg.indexOf("Edg") > -1) {
    sBrowser = "Microsoft Edge (Chromium)";
    // Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.124 Safari/537.36 Edg/91.0.864.64
  } else if (sUsrAg.indexOf("Chrome") > -1) {
    if (
      (window.navigator as any).userAgentData &&
      (window.navigator as any).userAgentData.brands
    ) {
      if (
        (window.navigator as any).userAgentData.brands?.[0].brand
          ?.toLowerCase()
          ?.indexOf("not a") > -1
      ) {
        sBrowser = "not chrome";
      } else {
        sBrowser = "mobile chrome";
      }
    } else {
      sBrowser = "mobile chrome";
    }

    // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
  } else if (sUsrAg.indexOf("Safari") > -1) {
    if (sUsrAg.indexOf("FxiOS") > -1) {
      sBrowser = "firefox ios";
    } else if (sUsrAg.indexOf("CriOS") > -1) {
      sBrowser = "chrome mobile ios";
    } else {
      sBrowser = "mobile safari";
    }
    // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
  } else {
    sBrowser = "unknown";
  }
  return sBrowser;
}

export function detectDeviceInfo(callBack: any) {
  const fpFull: FpModel = JSON.parse(localStorage.getItem("fpFull"));
  let os = getOS();
  let browserName = getBrowserName();
  let strAlert = `Detect: ${browserName?.toLowerCase()}, `;
  if (fpFull?.browserName && fpFull?.os) {
    os = fpFull?.os;
    browserName = fpFull?.browserName;
    strAlert += `FP: ${browserName?.toLowerCase()}`;
  }
  if (os?.toLowerCase() === "android") {
    if (
      browserName?.toLowerCase()?.indexOf("zalo") < 0 &&
      browserName?.toLowerCase()?.indexOf("chrome") > -1
    ) {
      browserName = getBrowserName();
    }
  }

  if (os?.toLowerCase() === "ios") {
    if (browserName.toLowerCase() === "mobile safari") {
      let temp = getBrowserName();
      switch (temp) {
        case "Microsoft Edge (Chromium)":
          browserName = "not safari";
          break;

        case "Microsoft Edge (Legacy)":
          browserName = "not safari";
          break;

        default:
          break;
      }
    }
  }
  // alert(strAlert + " userAgent: " + navigator.userAgent);
  callBack({
    os: os?.toLowerCase(),
    browserName: browserName?.toLowerCase(),
  });
}

export function appInitializer() {
  return () =>
    new Promise((resolve) => {
      if (
        !localStorage.getItem("reNewFPUG_1715589630747") ||
        !localStorage.getItem("_fp")
      ) {
        FingerprintJS.load({
          apiKey: "iNU7SDz8wrvkSKi7RpvZ",
          endpoint: [
            "https://quatangunilever.vn/dcmXiuoB3APah3BG/oT074iHLHBQn2dVO",
            defaultEndpoint,
          ],
          scriptUrlPattern: [
            "https://quatangunilever.vn/dcmXiuoB3APah3BG/4RrOiKdxnSkgetdI?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>",
            defaultScriptUrlPattern,
          ],
        })
          .then((fp) => fp.get({ extendedResult: true }))
          .then((result) => {
            localStorage.setItem("reNewFPUG_1715589630747", "true");
            var res: any = result;
            // let feModel: FpModel = res;
            // if (feModel?.incognito) {
            //   window.location.assign(window.location.hostname + "/browser");
            // }
            let fpFull = JSON.stringify(res);
            localStorage.setItem("fpFull", fpFull);
            localStorage.setItem("_fp", res.visitorId);
            resolve(true);
          })
          .catch((err) => {
            resolve(true);
            const request = {
              type: "fingerprint",
              content:
                "@ResponseAPI: " +
                err.message +
                " @UserAgent: " +
                navigator.userAgent,
              // +
              // " @UserInfo: " +
              // localStorage.getItem(AppConsts.currentShoperKey),
            };
            fetch(environment.unileverApiHost + "/Logger/Logger", {
              method: "POST",
              body: JSON.stringify(request), // string or object
              headers: environment.requestHeader,
            }).then((re) => console.log(re));
          });
      } else {
        resolve(true);
      }
    });
}

function callFp(callBack?: any, router?: Router) {
  if (
    !localStorage.getItem("reNewFPUG_1715589630747") ||
    !localStorage.getItem("_fp") ||
    !localStorage.getItem("_fp_location")
  ) {
    FingerprintJS.load({
      apiKey: "iNU7SDz8wrvkSKi7RpvZ",
      endpoint: [
        "https://quatangunilever.vn/dcmXiuoB3APah3BG/oT074iHLHBQn2dVO",
        defaultEndpoint,
      ],
      scriptUrlPattern: [
        "https://quatangunilever.vn/dcmXiuoB3APah3BG/4RrOiKdxnSkgetdI?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>",
        defaultScriptUrlPattern,
      ],
    })
      .then((fp) => fp.get({ extendedResult: true }))
      .then((result) => {
        localStorage.setItem("reNewFPUG_1715589630747", "true");
        var res: any = result;
        let feModel: FpModel = res;
        if (feModel?.incognito && environment.isEnableBlockBrowser) {
          router.navigate([ugiftPath.browser.path]);
          return false;
        }
        let fpFull = JSON.stringify(res);
        localStorage.setItem("fpFull", fpFull);
        localStorage.setItem("_fp", res.visitorId);

        localStorage.setItem("_fp_location", res.ipLocation.city.name);
        if (AppComponent.isValidateBrowser) {
          const fpFull: FpModel = JSON.parse(localStorage.getItem("fpFull"));
          if (fpFull?.browserName && fpFull?.os) {
            detectDeviceInfo((info) => {
              console.log("info >>>", info);

              if (info?.os === "ios") {
                if (
                  !ALLOW_BROWSERS_IOS.includes(info?.browserName) &&
                  environment.isEnableBlockBrowser
                ) {
                  router.navigate([ugiftPath.browserIphone.path]);
                  return false;
                }
              } else {
                if (info?.os === "android") {
                  if (
                    !ALLOW_BROWSERS_ANDROID.includes(info?.browserName) &&
                    environment.isEnableBlockBrowser
                  ) {
                    router.navigate([ugiftPath.browserAndroid.path]);
                    return false;
                  }
                } else {
                  if (environment.isEnableBlockBrowser) {
                    router.navigate([ugiftPath.browser.path]);
                  }
                }
              }
            });
          }
        }
        callBack?.();
      })
      .catch((err) => {
        callBack?.();
        if (AppComponent.isValidateBrowser) {
          const fpFull: FpModel = JSON.parse(localStorage.getItem("fpFull"));
          if (fpFull?.browserName && fpFull?.os) {
            detectDeviceInfo((info) => {
              console.log("info >>>", info);
              if (info?.os === "ios") {
                if (
                  !ALLOW_BROWSERS_IOS.includes(info?.browserName) &&
                  environment.isEnableBlockBrowser
                ) {
                  router.navigate([ugiftPath.browserIphone.path]);
                  return false;
                }
              } else {
                if (info?.os === "android") {
                  if (
                    !ALLOW_BROWSERS_ANDROID.includes(info?.browserName) &&
                    environment.isEnableBlockBrowser
                  ) {
                    router.navigate([ugiftPath.browserAndroid.path]);
                    return false;
                  }
                } else {
                  if (environment.isEnableBlockBrowser) {
                    router.navigate([ugiftPath.browser.path]);
                  }
                }
              }
            });
          }
        }
      });
  } else {
    callBack?.();
    if (AppComponent.isValidateBrowser) {
      const fpFull: FpModel = JSON.parse(localStorage.getItem("fpFull"));
      if (fpFull?.browserName && fpFull?.os) {
        detectDeviceInfo((info) => {
          console.log("info >>>", info);
          if (info?.os === "ios") {
            if (
              !ALLOW_BROWSERS_IOS.includes(info?.browserName) &&
              environment.isEnableBlockBrowser
            ) {
              router.navigate([ugiftPath.browserIphone.path]);
              return false;
            }
          } else {
            if (info?.os === "android") {
              if (
                !ALLOW_BROWSERS_ANDROID.includes(info?.browserName) &&
                environment.isEnableBlockBrowser
              ) {
                router.navigate([ugiftPath.browserAndroid.path]);
                return false;
              }
            } else {
              if (environment.isEnableBlockBrowser) {
                router.navigate([ugiftPath.browser.path]);
              }
            }
          }
        });
      }
    }
  }
}

export function getFP(callBack?: any, router?: Router) {
  return new Promise((resolve) => {
    callFp(callBack, router);
    resolve(true);
  });
}

export function ClearLocalStorageAndkeepFP(callBack?: any) {
  let fpFull = localStorage.getItem("fpFull");
  let _fp = localStorage.getItem("_fp");
  let _fp_location = localStorage.getItem("_fp_location");
  let reNewFPUG_1715589630747 = localStorage.getItem("reNewFPUG_1715589630747");
  localStorage.clear();
  if (_fp && fpFull) {
    localStorage.setItem("fpFull", fpFull);
    localStorage.setItem("_fp", _fp);
    localStorage.setItem("_fp_location", _fp_location);
    localStorage.setItem("reNewFPUG_1715589630747", reNewFPUG_1715589630747);
  }
  setTimeout(() => {
    callBack?.();
  }, 300);
}

export const Browser = {
  EDGE: "edge",
  OPERA: "opera",
  CHROME: "chrome",
  IE: "trident",
  FIREFOX: "firefox",
  SAFARI: "safari",
  OTHER: "other",
};
